import { useEffect } from 'react'

const useScedular: any = (service: any, time: number) => {
    useEffect(() => {
        service()
        const interval = setInterval(() => {
            service()
        }, time)

        return () => {
            clearInterval(interval)
        }
    }, [])
}

export default useScedular
